import { isNullOrUndefined } from '@standardnotes/utils';
import { RawStorageKey, StorageKey, namespacedKey, ValueModesKeys } from '@standardnotes/services';
import { StorageReader } from '../Reader';
import { PreviousSnjsVersion2_0_0 } from '@Lib/Version';
export class StorageReader2_0_0 extends StorageReader {
    static version() {
        return PreviousSnjsVersion2_0_0;
    }
    async getStorage() {
        const storageKey = namespacedKey(this.identifier, RawStorageKey.StorageObject);
        const storage = await this.deviceInterface.getRawStorageValue(storageKey);
        const values = storage ? JSON.parse(storage) : undefined;
        return values;
    }
    async getNonWrappedValue(key) {
        var _a;
        const values = await this.getStorage();
        if (!values) {
            return undefined;
        }
        return (_a = values[ValueModesKeys.Nonwrapped]) === null || _a === void 0 ? void 0 : _a[key];
    }
    /**
     * In 2.0.0+, account key params are stored in NonWrapped storage
     */
    async getAccountKeyParams() {
        return this.getNonWrappedValue(StorageKey.RootKeyParams);
    }
    async hasNonWrappedAccountKeys() {
        const value = await this.deviceInterface.getNamespacedKeychainValue(this.identifier);
        return !isNullOrUndefined(value);
    }
    async hasPasscode() {
        const wrappedRootKey = await this.getNonWrappedValue(StorageKey.WrappedRootKey);
        return !isNullOrUndefined(wrappedRootKey);
    }
    usesKeychain() {
        return true;
    }
}
